export const AUTH_STATUS_CHANGED = `user/AUTH_STATUS_CHANGED`
export const USER_UPDATE = `user/USER_UPDATE`
export const USER_UPDATED = `user/USER_UPDATED`
export const LOG_OUT = `user/LOG_OUT`
export const AUTHENTICATING = `user/AUTHENTICATING`
export const AUTHENTICATE_WITH_CREDENTIAL = `user/AUTHENTICATE_WITH_CREDENTIAL`
export const AUTH_FAILED = `user/AUTH_FAILED`
export const USER_UPDATE_PRESENCE = `user/USER_UPDATE_PRESENCE`
export const USER_UPDATE_ACTIVE_ROUTE = `user/USER_UPDATE_ACTIVE_ROUTE`
